export class TituloPaginaModel {
    public modulo!: string;
    public subtitulo?: string;
    public categoria?: string;
    public titulo!: string;
}
